import isToday from 'date-fns/isToday';
import isYesterday from 'date-fns/isYesterday';
import { otherSingularActivityMessages, pluralActivityMessages, youSingularActivityMessages } from './messages';
export var descriptionHelper = function descriptionHelper(_ref) {
  var currentUserId = _ref.currentUserId,
    event = _ref.event,
    contributors = _ref.contributors,
    othersCount = _ref.othersCount,
    timestamp = _ref.timestamp,
    formatMessage = _ref.formatMessage,
    formatDate = _ref.formatDate;
  var involvesCurrentUser = contributors.some(function (contributor) {
    return contributor.id === currentUserId;
  });

  // If the event is singular with a single contributor
  if (contributors.length === 1) {
    var formattedDate = formatDate(timestamp, {
      month: 'long',
      day: 'numeric',
      year: 'numeric'
    });
    var message;
    switch (event) {
      case 'created':
        message = involvesCurrentUser ? youSingularActivityMessages.created : otherSingularActivityMessages.created;
        break;
      case 'edited':
        message = involvesCurrentUser ? youSingularActivityMessages.edited : otherSingularActivityMessages.edited;
        break;
      case 'commented':
        message = involvesCurrentUser ? youSingularActivityMessages.commented : otherSingularActivityMessages.commented;
        break;
      case 'updated':
        message = involvesCurrentUser ? youSingularActivityMessages.updated : otherSingularActivityMessages.updated;
        break;
      case 'worked':
      default:
        message = involvesCurrentUser ? youSingularActivityMessages.worked : otherSingularActivityMessages.worked;
        break;
    }
    if (isToday(timestamp)) {
      return involvesCurrentUser ? formatMessage(message.today) : formatMessage(message.today, {
        name: contributors[0].name
      });
    } else if (isYesterday(timestamp)) {
      return involvesCurrentUser ? formatMessage(message.yesterday) : formatMessage(message.yesterday, {
        name: contributors[0].name
      });
    } else {
      return involvesCurrentUser ? formatMessage(message.otherTime, {
        time: formattedDate
      }) : formatMessage(message.yesterday, {
        name: contributors[0].name,
        time: formattedDate
      });
    }
  }
  // If the activity is plural with more than one contributor
  else {
    if (involvesCurrentUser) {
      var contributorsWithoutCurrentUser = contributors.filter(function (contributor) {
        return contributor.id !== currentUserId;
      });
      if (othersCount > 0) {
        return formatMessage(pluralActivityMessages.you.many, {
          name1: contributorsWithoutCurrentUser[0].name,
          count: othersCount
        });
      } else {
        return contributors.length === 2 ? formatMessage(pluralActivityMessages.you.double, {
          name1: contributorsWithoutCurrentUser[0].name
        }) : formatMessage(pluralActivityMessages.you.triple, {
          name1: contributorsWithoutCurrentUser[0].name,
          name2: contributorsWithoutCurrentUser[1].name
        });
      }
    } else {
      if (othersCount > 0) {
        return formatMessage(pluralActivityMessages.other.many, {
          name1: contributors[0].name,
          name2: contributors[1].name,
          count: othersCount
        });
      } else {
        return contributors.length === 2 ? formatMessage(pluralActivityMessages.other.double, {
          name1: contributors[0].name,
          name2: contributors[1].name
        }) : formatMessage(pluralActivityMessages.other.triple, {
          name1: contributors[0].name,
          name2: contributors[1].name,
          name3: contributors[2].name
        });
      }
    }
  }
};